module.exports = __webpack_public_path__ + "img/zizhi5.f5534f88.jpg";